import { EMPTY_VALUE_PLACEHOLDER } from "../models/common/data";
import { Maybe } from "../models/common/generic-types";
import { isEmptyValue } from "./is-empty-value";

/**
 * @description creates a formatted currency value, defaults to CH if no currency code is provided
 * @param val the currency value
 * @param currency the currency code
 * @param maximumFractionDigits
 */
export default (
	val: Maybe<string | number> | undefined,
	currency?: string | undefined | null,
	maximumFractionDigits?: number,
	minimumFractionDigits?: number,
	addSign?: boolean
) => {
	if (isEmptyValue(val) || isNaN(+(val as any))) {
		return EMPTY_VALUE_PLACEHOLDER;
	}
	const defaultCurrency = "CHF";

	return `${addSign && +(val as any) > 0 ? "+" : ""}${(+(val as any)).toLocaleString("en", {
		maximumFractionDigits: maximumFractionDigits || 0,
		minimumFractionDigits: minimumFractionDigits || 0,
	})} ${currency || defaultCurrency}`;
};
